module.exports = __webpack_public_path__ + "static/media/fixed-phone.31a0254e.svg";